import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/components/LandingPage";
import Admin from "@/components/Admin";
import MembershipSuccess from "@/components/MembershipSuccess";
import LegalPage from "@/components/LegalPage";
import TrainingSuccess from "@/components/TrainingSuccess";
import TrainingPage from "@/components/training/TrainingPage";
import LessonsPage from "@/components/training/LessonsPage";
import Scoreboard from "@/components/Scoreboard";
import LeaderboardPage from "@/components/Leaderboard";
import SignWaiver from "@/components/SignWaiver";
import { useParams } from "react-router-dom";

function LegacyProgramRedirect() {
  const { discipline } = useParams();
  return <Navigate to={`/training/${discipline}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/membership/success" element={<MembershipSuccess />} />
          <Route path="/training/success" element={<TrainingSuccess />} />
          <Route path="/training/:category" element={<TrainingPage />} />
          <Route path="/lessons" element={<LessonsPage />} />
          <Route path="/scoreboard/:token" element={<Scoreboard />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/sign/:token" element={<SignWaiver />} />
          <Route path="/programs/:discipline" element={<LegacyProgramRedirect />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
